import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@mui/styles';
import css from './SharingLink.css';
import Tooltip from '../../components/molecules/Tooltip';
import TrashIcon from '../../resources/svg/trash.svg';
import EditIcon from '../../resources/svg/edit.svg';
import Icon, { IconSizes } from '../../components/foundations/Icon';

const styles = () => ({
    tooltip: {
        fontSize: 11,
    },
});

const LargeTooltip = withStyles(styles)(Tooltip);

const SharingLink = ({
    displayName = '',
    externalId = '',
    onCopySharingLink = () => {},
    onRevokeSharingLink = () => {},
    onRenameSharingLink = () => {},
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const nameInputRef = useRef(null);

    const handleCopySharingLink = () => {
        onCopySharingLink(externalId);
    };

    const handleRevokeSharingLink = () => {
        onRevokeSharingLink(externalId);
    };

    const handleEditDone = () => {
        const displayNameValue = nameInputRef.current.value;
        setIsEditing(false);

        if (!displayNameValue || displayNameValue === displayName) {
            return;
        }

        onRenameSharingLink(externalId, displayNameValue);
    };

    const handleStartEdit = () => {
        setIsEditing(true);
    };

    useEffect(() => {
        if (isEditing && nameInputRef.current) {
            nameInputRef.current.focus();
        }
    }, [isEditing]);

    return (
        <div className={css.container}>
            <input
                type="text"
                ref={nameInputRef}
                onBlur={handleEditDone}
                onClick={handleStartEdit}
                readOnly={!isEditing}
                className={classNames(css.linkName, { [css.editing]: isEditing })}
                defaultValue={displayName}
            />
            <div className={css.buttonsArea}>
                <LargeTooltip titleTranslationKey="STATIC.PAGES.AUDIENCES.SHARING_OPTIONS_RENAME_TOOLTIP">
                    <div
                        onClick={handleStartEdit}
                        className={classNames(css.buttonContainer, css.edit, { [css.active]: isEditing })}
                    >
                        <EditIcon />
                    </div>
                </LargeTooltip>
                <LargeTooltip titleTranslationKey="STATIC.PAGES.AUDIENCES.SHARING_OPTIONS_COPY_TOOLTIP">
                    <div onClick={handleCopySharingLink} className={css.buttonContainer}>
                        <Icon name="copy" size={IconSizes.SMALL} />
                    </div>
                </LargeTooltip>
                <LargeTooltip titleTranslationKey="STATIC.PAGES.AUDIENCES.SHARING_OPTIONS_REVOKE_TOOLTIP">
                    <div onClick={handleRevokeSharingLink} className={classNames(css.buttonContainer, css.delete)}>
                        <TrashIcon />
                    </div>
                </LargeTooltip>
            </div>
        </div>
    );
};

SharingLink.propTypes = {
    displayName: PropTypes.string,
    externalId: PropTypes.string,
    onCopySharingLink: PropTypes.func,
    onRevokeSharingLink: PropTypes.func,
    onRenameSharingLink: PropTypes.func,
};

export default SharingLink;
